export default __webpack_public_path__ + "static/media/SDG-icon-NL-11.dcb82d6a.svg";